import React, { Component } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import TextField from "@mui/material/TextField";

import { observer, inject } from "mobx-react";

import { getEmergency } from "../../utils/operations.js";
import API from "../../utils/api";
import {toast} from "react-toastify";

const style = {
  width: 500,
  margin: 20,
  padding: 20,
  textAlign: "center",
  display: "inline-block",
  borderWidth: 1,
  borderRadius: "20px",
  boxShadow: "inset 0px 0px 20px rgba(0,0,0,0.2)"
};

class EditEmergency extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orgId: 0,
      opendialog: false, // Диалог с ошибками
      texterrors: "", // Список ошибок
      school: "",
      name: "",
      relation: "",
      phone: "",
      id: 0,
      allergies: "",
      isEdit: false
    };
  }

  componentDidMount() {
    let pathname = this.props.location.pathname;
    let itemId = pathname.replace("/editemergency/:", "");
    if (itemId !== "new") {
      this.setState({ isEdit: true });
      this.setState({ id: itemId });
      this.loadEmergency(itemId);
    }
  }

  loadEmergency = async (itemId) => {
    try {
      const res = await API.get(getEmergency + "/" + itemId)
      let emergency = res.data;
      this.setState({ name: emergency.name, relation: emergency.relation, phone: emergency.phone  });
    } catch (e) {
      this.setState({ texterrors: e.message });
    }
  };

  handleOpen = () => {
    this.setState({ opendialog: true });
  };

  handleClose = () => {
    this.setState({ opendialog: false });
  };

  handleChangeName = e => {
    this.setState({ name: e.target.value });
  };

  handleChangePhone = e => {
    this.setState({ phone: e.target.value });
  };

  handleChangeRelation = e => {
    this.setState({ relation: e.target.value });
  };

  deleteEmergency = async () => {
    try {
      await API.delete(getEmergency + "/" + this.state.id);

      const goUrl = "/editchild/" + this.props.Auth.child_id;
      setTimeout(this.props.history.push(goUrl), 1000);
    } catch (e) {
      this.setState({ texterrors: e.message });
      this.handleOpen();
    }
  };

  saveInfo = async () => {
    const emergencyData = {
      child_id: this.props.Auth.child_id,
      name: this.state.name,
      relation: this.state.relation,
      phone: this.state.phone
    };

    try {
      if (this.state.isEdit) {
        await API.patch(getEmergency + "/" + this.state.id, emergencyData);
        toast.success("Emergency was updated successfully")
      } else {
        const data = {resource: [emergencyData]};
        await API.post(getEmergency, data);
        toast.success("Emergency was added successfully")
      }

      const goUrl = "/editchild/" + this.props.Auth.child_id;
      setTimeout(this.props.history.push(goUrl), 2000);
    } catch (e) {
      this.setState({ texterrors: e.message });
      this.handleOpen();
    }
  };

  goPreviousPage = () => {
    this.props.history.goBack();
  };

  render() {
    return (
      <div style={{ margin: "auto", width: 700 }}>
        <div style={style}>
          <span>Emergency contacts</span>
          <br />
          <TextField
            label="Name"
            placeholder="Name"
            fullWidth
            value={this.state.name}
            onChange={this.handleChangeName}
          />
          <br />
          <TextField
            label="Relation"
            placeholder="Relation"
            fullWidth
            value={this.state.relation}
            onChange={this.handleChangeRelation}
          />
          <br />
          <TextField
            label="Phone Number"
            placeholder="Phone Number"
            fullWidth
            value={this.state.phone}
            onChange={this.handleChangePhone}
          />
          <br />
          <br />
        </div>
        <br />
        <div
          style={{
            margin: "auto",
            width: 400,
            paddingTop: 20,
            paddingBottom: 20
          }}
        >
          <Button
            variant="contained"
            color="primary"
            style={{ marginRight: 10 }}
            onClick={this.saveInfo}
          >Save</Button>
          <Button
            variant="contained"
            color="primary"
            style={{ marginLeft: 10 }}
            onClick={this.goPreviousPage}
          >Cancel</Button>
          <Button
            variant="contained"
            color="secondary"
            style={{ marginLeft: 10 }}
            onClick={this.handleOpen}
          >Delete</Button>
          <Dialog
            open={this.state.opendialog}
            onClose={this.handleClose}
            maxWidth="xs"
          >
            <DialogContent>
              {this.state.texterrors ? this.state.texterrors : "Delete Emergency?"}
            </DialogContent>
            <DialogActions>
              <Button onClick={this.handleClose}>Cancel</Button>
              <Button color="primary" onClick={this.deleteEmergency}>OK</Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}

export default inject("Auth")(observer(EditEmergency))
